import { render, staticRenderFns } from "./UbicacionesComponent.vue?vue&type=template&id=062b1538&scoped=true"
import script from "./UbicacionesComponent.vue?vue&type=script&lang=js"
export * from "./UbicacionesComponent.vue?vue&type=script&lang=js"
import style0 from "./UbicacionesComponent.vue?vue&type=style&index=0&id=062b1538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062b1538",
  null
  
)

export default component.exports